import { render, staticRenderFns } from "./turnCardDialog.vue?vue&type=template&id=1f30e8b9&scoped=true&"
import script from "./turnCardDialog.vue?vue&type=script&lang=js&"
export * from "./turnCardDialog.vue?vue&type=script&lang=js&"
import style0 from "./turnCardDialog.vue?vue&type=style&index=0&id=1f30e8b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f30e8b9",
  null
  
)

export default component.exports